import logo from "@/assets/logo.png";

export function BrandLogo({ className = "", ...props }) {
  return (
    <img
      src={logo}
      alt="I AM Social, Agência de Marketing Digital"
      className={`block object-contain ${className}`}
      {...props}
    />
  );
}
